import { render } from "./NavbarComponent.vue?vue&type=template&id=25f13d25&scoped=true&ts=true"
import script from "./NavbarComponent.vue?vue&type=script&lang=ts"
export * from "./NavbarComponent.vue?vue&type=script&lang=ts"

import "./NavbarComponent.vue?vue&type=style&index=0&id=25f13d25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f13d25"]])

export default __exports__